import React from 'react';
import { connect } from 'react-redux';
import Card from 'react-bootstrap/Card';
import { ccsdCodeListFetch, ccsdCodeListSetPage, ccsdCodeListUnload } from '../../lib/redux/actions/ccsdCodes';
import MASpinner from '../../components/common/MASpinner';
import Alert from 'react-bootstrap/Alert';
import Paginator from '../../components/common/Paginator';
import * as ROUTES from '../../lib/routing/frontend';
import CcsdCodeListTable from './CcsdCodeListTable';
import CcsdCodeTableFilterForm from '../../components/forms/CcsdCode/CcsdCodeTableFilterForm';
import { getFiltersFromSession } from '../../lib/routing/filters';
import AppliedFiltersOutput from '../../components/common/AppliedFiltersOutput';

const mapStateToProps = (state) => ({
  ...state.ccsdCodes,
});

const mapDispatchToProps = {
  ccsdCodeListFetch,
  ccsdCodeListSetPage,
  ccsdCodeListUnload,
};

class CcsdCodeListContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilters: false,
    };
  }

  getCombinedFilters() {
    const { filters, defaultFilters = {}, match } = this.props;
    let filtersFromSession = getFiltersFromSession(match.path, 'json');
    return { ...filters, ...defaultFilters, ...filtersFromSession };
  }

  componentWillUnmount() {
    this.props.ccsdCodeListUnload();
  }

  componentDidMount() {
    this.props.ccsdCodeListFetch(this.getQueryParamPage(), this.getCombinedFilters());
  }

  componentDidUpdate(prevProps) {
    const { currentPage, ccsdCodeListFetch, ccsdCodeListSetPage, filters } = this.props;

    if (prevProps.match.params.page !== this.getQueryParamPage()) {
      ccsdCodeListSetPage(this.getQueryParamPage());
    }
    if (prevProps.currentPage !== currentPage || prevProps.filters !== filters) {
      ccsdCodeListFetch(currentPage, this.getCombinedFilters());
    }
  }

  getQueryParamPage() {
    return Number(this.props.match.params.page) || 1;
  }

  changePage(page) {
    const { history, ccsdCodeListSetPage } = this.props;
    ccsdCodeListSetPage(page);
    history.push(ROUTES.CCSD_CODES.ALL.replace(':page', page));
  }

  nextPage() {
    const { currentPage, pageCount } = this.props;
    const newPage = Math.min(currentPage + 1, pageCount);
    this.changePage(newPage);
  }

  prevPage() {
    const { currentPage } = this.props;
    const newPage = Math.max(currentPage - 1, 1);
    this.changePage(newPage);
  }

  toggleFilters() {
    this.setState((prevState) => {
      return { showFilters: !prevState.showFilters };
    });
  }

  render() {
    const { ccsdCodes, isFetchingCcsdCodes, pageTitle, pageCount, currentPage } = this.props;

    return (
      <Card>
        <Card.Header>
          <div className="d-flex justify-content-between">
            {' '}
            {pageTitle}
            {!isFetchingCcsdCodes && ccsdCodes && ccsdCodes.length > 0 && (
              <div>
                <button className="btn btn-sm btn-outline-secondary mr-3" onClick={this.toggleFilters.bind(this)}>
                  Filters
                </button>
                <span className="tabular-data-result-count">{pageCount} pages</span>
              </div>
            )}
          </div>
        </Card.Header>

        {this.state.showFilters && (
          <Card.Body className={'mediaccount-filter-wrapper'}>
            <CcsdCodeTableFilterForm location={this.props.match.path} />
          </Card.Body>
        )}

        {isFetchingCcsdCodes && (
          <Card.Body>
            <MASpinner />
          </Card.Body>
        )}

        {!isFetchingCcsdCodes && (ccsdCodes === null || ccsdCodes.length === 0) && (
          <Card.Body>
            <Alert variant={'info'} className="mb-0">
              No CCSD Codes found
            </Alert>
          </Card.Body>
        )}

        <AppliedFiltersOutput />

        {!isFetchingCcsdCodes && ccsdCodes && ccsdCodes.length > 0 && <CcsdCodeListTable ccsdCodes={ccsdCodes} />}
        {!isFetchingCcsdCodes && ccsdCodes && ccsdCodes.length > 0 && (
          <Paginator
            currentPage={currentPage}
            pageCount={pageCount}
            setPage={this.changePage.bind(this)}
            nextPage={this.nextPage.bind(this)}
            prevPage={this.prevPage.bind(this)}
          />
        )}
      </Card>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CcsdCodeListContainer);
